export default "__VITE_ASSET__BrGFZBpM__"